import React, { Component } from "react";

export default class Header extends Component {
	

	handleRouteToHome = () => {
		this.props.history.push('/')
	}

	componentDidMount(){
		let logo = document.querySelector(".logo");
		logo.focus();
		document.addEventListener('keyup',this.closeKeyUp);
	}

	keyUp=(e)=>{
		if(e.keyCode===13){
			this.props.toggleBox();
		}
	}
	closeKeyUp= (e) => {
		if(e.keyCode===27){
        	this.props.closeBox();
		}
	}

	render() {
		return (
			<div className="SiteHeader">
				<div className="dx-col">
					<div className="logo-area">
						<div className="dx-col">

							<div className="logo" onClick={this.handleRouteToHome} tabIndex="0">
									<img src="https://www.privateclientselect.com/content/dam/aig/america-canada/us_pcs/images/pcs/pcs-logo-rgb-2col-whi-gold.png" alt="PCS Brand - Navigate to Welcome Screen"/>

							</div>
							<div className="logo-title">
								Private Client Select
							</div>
						</div>
					</div>
					<div className="support-info-object top-support-info-object">
						<div className="dx-col" onKeyUp={(e)=>{this.keyUp(e)}}>
							<div
								className="support-info-trigger"
								id="support-info-trigger"
								onClick={this.props.toggleBox}>
								<div className="dx-col" tabIndex="0" id="support-trigger">
									<div className="icon-support">
										<svg
											aria-labelledby="supportIconID"
											width="64"
											height="64"
											viewBox="0 0 64 64"
											xmlns="http://www.w3.org/2000/svg">
											<title id="supportIconId">Phone</title>
											<path
												d="M32 64C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32zm9.753-27.012a4.32 4.32 0 0 0-2.671.313l-2.999 1.294a29.482 29.482 0 0 1-5.314-4.215 28.8 28.8 0 0 1-4.174-5.392l.98-2.699a4.383 4.383 0 0 0 .258-2.595l-1.996-7.79-10.185 1.467.042.62a33.593 33.593 0 0 0 9.649 21.564 33.12 33.12 0 0 0 21.954 9.74h.661l1.085-10.602-7.29-1.705z"
												id="a"
												fill="#fff"
											/>
										</svg>
									</div>
									<div className="icon-support-text">
										Support
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/Header/Header.js